// src/components/organisms/landing/section-faqs/faqs-data.ts
import type { FaqEntry } from "@/components/molecules/landing/faq-item";
import type { FaqCategory } from "@/components/molecules/landing/faq-filter-tabs";

export const faqs: FaqEntry[] = [
  {
    id: "faq-01",
    index: "01.",
    question: "Does Niftipay support both card and crypto payments?",
    answer:
      "Yes. Card, crypto, and stablecoin transactions are supported through a unified infrastructure layer.",
    category: "Payment",
  },
  {
    id: "faq-02",
    index: "02.",
    question:
      "Is Niftipay suitable for complex or restricted commerce environments?",
    answer:
      "Yes. Niftipay is designed for payment acceptance in environments where traditional processors may be limited or inconsistent.",
    category: "Product",
  },
  {
    id: "faq-03",
    index: "03.",
    question: "How is access structured?",
    answer:
      "Access is subject to review and verification. Integration begins after approval.",
    category: "Compliant",
  },
  {
    id: "faq-04",
    index: "04.",
    question: "What currencies are supported by Niftipay?",
    answer:
      "Niftipay supports a wide range of fiat and cryptocurrencies, including USD, EUR, BTC, ETH, and more.",
    category: "Payment",
  },
  {
    id: "faq-05",
    index: "05.",
    question: "Can Niftipay be integrated with e-commerce platforms?",
    answer:
      "Yes. Niftipay ships plugins for WooCommerce and PrestaShop, and a REST API with webhooks for any other platform.",
    category: "Integration",
  },
  {
    id: "faq-06",
    index: "06.",
    question: "What security measures does Niftipay implement?",
    answer:
      "Niftipay uses advanced encryption, two-factor authentication, and regular security audits to ensure transaction safety.",
    category: "Compliant",
  },
  {
    id: "faq-07",
    index: "07.",
    question: "Are there transaction limits with Niftipay?",
    answer:
      "Yes, transaction limits vary based on user verification level and compliance requirements.",
    category: "Payment",
  },
  {
    id: "faq-08",
    index: "08.",
    question: "Does Niftipay provide customer support?",
    answer:
      "Yes, customer support is available 24/7 through various channels including chat, email, and phone.",
    category: "Product",
  },
  {
    id: "faq-09",
    index: "09.",
    question: "What fees are associated with Niftipay transactions?",
    answer:
      "Niftipay operates with competitive transaction fees, which are clearly outlined during the onboarding process.",
    category: "Payment",
  },
  {
    id: "faq-10",
    index: "10.",
    question: "How long does it take to set up Niftipay?",
    answer:
      "Setting up Niftipay typically takes a few days, depending on the verification process and integration complexity.",
    category: "Integration",
  },
];

export type ContactCta = {
  label: string;
  href: string;
  external?: boolean;
  icon: "email" | "telegram" | "docs";
};

export type FaqsContent = {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  faqs: FaqEntry[];
  categories: FaqCategory[];
  contactPrompt?: string;
  contactCtas?: ContactCta[];
};

export const defaultFaqsContent: FaqsContent = {
  eyebrow: "Common questions",
  title: "Frequently asked questions",
  description:
    "Quick answers to the most common questions about using automated bot stores for regulated and high-risk commerce.",
  faqs,
  categories: [
    "All",
    "Product",
    "Payment",
    "Compliant",
    "Integration",
    "Optimization",
    "Automation",
  ],
  contactPrompt: "Still need help or have more questions?",
  contactCtas: [
    { label: "Email", href: "mailto:support@niftipay.com", external: true, icon: "email" },
    { label: "Telegram", href: "https://t.me/niftipay", external: true, icon: "telegram" },
    { label: "Docs", href: "/docs", icon: "docs" },
  ],
};
